// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__pFy-I","importantInfo":"styles_importantInfo__HnQzs"};